import { baseApi } from '../baseApi';

export interface Carousel {
  id: string;
  header: string;
  text: string;
  imageUrl: string;
  route: string;
  isActive: boolean;
  order: number;
  classId: string;
  createdAt: string;
  updatedAt: string;
}

export interface ListParams {
  search?: string;
  isActive?: string;
  [key: string]: any;
}

export const carouselApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCarousels: builder.query<{ success: boolean; data: Carousel[] }, ListParams | void>({
      query: (params) => ({
        url: '/api/carousels',
        params: params || undefined,
      }),
      providesTags: ['Carousel'],
    }),
    createCarousel: builder.mutation<{ success: boolean; data: Carousel }, Partial<Carousel>>({
      query: (body) => ({
        url: '/api/carousels',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Carousel', 'Dashboard'],
    }),
    updateCarousel: builder.mutation<{ success: boolean; data: Carousel }, { id: string; body: Partial<Carousel> }>({
      query: ({ id, body }) => ({
        url: `/api/carousels/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['Carousel', 'Dashboard'],
    }),
    deleteCarousel: builder.mutation<{ success: boolean; message: string }, string>({
      query: (id) => ({
        url: `/api/carousels/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Carousel', 'Dashboard'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetCarouselsQuery,
  useCreateCarouselMutation,
  useUpdateCarouselMutation,
  useDeleteCarouselMutation,
} = carouselApi;
